import type { PHBand } from './types';

/** The pH paper's own resulting tint — red for acid, green for neutral, blue
 *  for base. Collapses the five pH bands to the three colours a strip of
 *  paper actually shows; a Class 10 bench has no use for a fourth or fifth
 *  shade between them. */
export function pHBandToHex(band: PHBand): string {
  switch (band) {
    case 'strongly_acidic':
    case 'acidic': return '#c0392b';
    case 'basic':
    case 'strongly_basic': return '#2b5fc0';
    default: return '#4caf50';
  }
}
